import type { DenormalizedBlockEntity, StructureEntityTypes } from '@web/types';

import { normalize, schema } from 'normalizr';

import { blockInstance } from '@web/store/page-structure/blocks/blocks.models';
import { columnInstance } from '@web/store/page-structure/columns/columns.models';
import { sectionInstance } from '@web/store/page-structure/sections/sections.models';

const blockEntity = blockInstance();
const sectionEntity = sectionInstance({ parentId: blockEntity.id });
const columnEntity = columnInstance({ parentId: sectionEntity.id });

export const widgetSchema = new schema.Entity('widgets');
export const gridSchema = new schema.Entity('widgets', {
    children: [new schema.Array(widgetSchema)],
});
export const tabSchema = new schema.Entity('widgets', {
    children: [gridSchema],
});

export const columnItemSchema = new schema.Union(
    {
        tab: tabSchema,
        grid: gridSchema,
        widget: widgetSchema,
    },
    (value) => {
        if (value && typeof value === 'object') {
            const entityType = (value as { entityType?: string }).entityType;
            if (entityType === 'tab') {
                return 'tab';
            }
            if (entityType === 'grid') {
                return 'grid';
            }
        }
        return 'widget';
    }
);

// `children`, not `widgets`, for the same reason as the section below.
export const columnSchema = new schema.Entity('columns', {
    children: [columnItemSchema],
});
// `children`, not `columns`: normalization runs on the structure the adapter has
// already migrated, and a v0 section keeps its columns under `children`.
export const sectionSchema = new schema.Entity('sections', {
    children: [columnSchema],
});
// `children`, not `sections`, for the same reason as the section and the column
// below: normalization runs on the structure the adapter has already migrated.
export const blockSchema = new schema.Entity<DenormalizedBlockEntity>('blocks', {
    children: [sectionSchema],
});

export const pageStructureSchema = new schema.Array<DenormalizedBlockEntity[]>(blockSchema);

type PageStructureSchema =
    | typeof pageStructureSchema
    | typeof blockSchema
    | typeof sectionSchema
    | typeof columnSchema
    | typeof tabSchema
    | typeof gridSchema
    | typeof widgetSchema;

export const webNormalize = (data: StructureEntityTypes | StructureEntityTypes[], dataSchema: PageStructureSchema) => {
    const normalizedData = normalize(data, dataSchema);
    let blocks = Object.values((normalizedData.entities as any)?.blocks || {}) as any;
    const sections = Object.values((normalizedData.entities as any)?.sections || {}) as any;
    const columns = Object.values((normalizedData.entities as any)?.columns || {}) as any;
    const widgets = Object.values((normalizedData.entities as any)?.widgets || {}) as any;
    if ('children' in data) {
        blocks = blocks[0];
    }
    return { blocks, sections, columns, widgets };
};

export const structureData = [
    {
        ...blockEntity,
        children: [
            {
                ...sectionEntity,
                children: [
                    {
                        ...columnEntity,
                        children: [
                            // {
                            //     id: uuid(),
                            //     columnId: columnEntity.id,
                            //     data: {
                            //         content: 'Lorem Ipsum',
                            //     },
                            // },
                        ],
                    },
                ],
            },
        ],
    },
];
